import { Observable, switchMap } from 'rxjs';

import { JwtAuthHeaders } from '../models/jwt-auth-headers';
import { retryWhenJwtAuthError } from './retry-when-jwt-auth-error';

export function withJwt(
  fetch: (jwtAuthHeaders: JwtAuthHeaders) => Observable<Response>
) {
  return new Observable<JwtAuthHeaders>((subscriber) => {
    subscriber.next(new JwtAuthHeaders());
    subscriber.complete();
  }).pipe(switchMap(fetch), retryWhenJwtAuthError());
}
